import { Component, Input, OnInit } from '@angular/core';
import { PageElementViewModel, ConferenceViewModel, ConferenceViewModelWithDetails, SearchFilterDataModel, OrganizationViewModel } from 'src/app/_models/generatedModels';
import { CourseService, OrganizationService } from 'src/app/_services/generatedServices';
import { OrganizationSearchService } from 'src/app/_services/on-demand-search-service';

@Component({
  selector: 'bxl-conference-on-demand-search',
  templateUrl: 'conference-on-demand-search.component.html',
})
export class ConferenceOnDemandSearchComponent implements OnInit {
  initialized = false;
  @Input() conference: ConferenceViewModel;
  @Input() organization: OrganizationViewModel;
  @Input() element: PageElementViewModel;
  filterData: SearchFilterDataModel;
  loadingMore: boolean;
  rootRoute: string;
  constructor(public searchService: OrganizationSearchService, private org: OrganizationService, private courseData: CourseService) {}

  ngOnInit(): void {
    var orgId = 0;
    if (this.conference) {
        orgId = this.conference.organizationId;
        this.rootRoute = '/conferences/' + this.conference.slug;
    }else{
      orgId = this.organization.id;
      this.rootRoute = '/organizations/' + this.organization.slug;
    }

    this.org.getOrganization(orgId.toString()).subscribe((orgResult) => {
      this.searchService.initialize(orgResult.id).then(() => {
        this.courseData.getFilterData().subscribe((result) => {
          this.filterData = result;
          this.initialized = true;
        });
      });
    });
  }

  loadMore() {
    this.loadingMore = true;
    this.searchService.loadMore().then(() => {
      this.loadingMore = false;
    });
  }
}
